"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
// Button component to download a CSV file.
const DownloadButtonComponent = ({ title, fileName, buttonColor = 'green' }) => {
    const handleDownload = () => {
        window.location.href = `/api/admin/data/${fileName}`;
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("button", { type: "button", onClick: handleDownload, className: `button big ${buttonColor}`, "aria-label": `${title}` }, title)));
};
// Button component to perform an action (not download)
const ActionButtonComponent = ({ title, actionUrl, buttonColor = 'blue' }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const [message, setMessage] = react_1.default.useState(null);
    const handleAction = () => __awaiter(void 0, void 0, void 0, function* () {
        setMessage(null);
        try {
            const response = yield fetch(actionUrl, { method: 'POST' });
            const result = yield response.json();
            if (response.ok) {
                // Translate the status code if it exists, otherwise use a generic success message
                const statusMessage = result.status
                    ? t(`surveyAdmin:${result.status}`)
                    : t('surveyAdmin:actionSuccess');
                setMessage('✔️ ' + statusMessage);
            }
            else {
                const errorMessage = result.error || t('surveyAdmin:actionError');
                setMessage('❌ ' + errorMessage);
            }
        }
        catch (err) {
            const msg = err instanceof Error ? err.message : String(err);
            setMessage(`❌ ${t('surveyAdmin:actionError')}: ${msg}`);
        }
    });
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("button", { type: "button", onClick: handleAction, className: `button big ${buttonColor}`, "aria-label": `${title}` }, title),
        message && react_1.default.createElement("div", null, message)));
};
// Component to display links to download CSV exports.
const CsvExports = () => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return (react_1.default.createElement("div", { className: "admin-widget-container" },
        react_1.default.createElement(ActionButtonComponent, { title: t('surveyAdmin:updateMonitoringCache'), actionUrl: "/api/admin/data/updateMonitoringCache", buttonColor: "blue" }),
        react_1.default.createElement(DownloadButtonComponent, { title: t('surveyAdmin:downloadTrackingData'), fileName: "downloadTrackingDataCSV", buttonColor: "green" })));
};
exports.default = CsvExports;
